import api from '@/services/api'

export type ValidateTestCodeResponse = {
  accessToken: string
  realtimeChannel: string
  realtimeMessageToken: string
  showOnboardingQuestions: boolean
  showTestResultToStudent: boolean
  showHubspotForm: string
  shouldRecordVideo: boolean
  redirectUrl?: string
  student: {
    _id: string
    name: string
    birthDate: Date
    company: { name: string }
  }
}

export const validateTestCode = async ({
  code,
  locale = 'en'
}: {
  code: string
  locale?: string
}): Promise<ValidateTestCodeResponse> => {
  const { data } = await api.post('fluency-test', {
    code,
    locale
  })
  return data
}

export default validateTestCode
